import api from '@/services/api';

/** OAuth / CDN hosts — use the URL directly, do not sign via S3. */
const EXTERNAL_IMAGE_HOSTS = [
  'licdn.com',
  'linkedin.com',
  'googleusercontent.com',
  'graph.facebook.com',
  'fbcdn.net',
  'gravatar.com',
];

export function shouldSignProfileImageUrl(imageUrl: string): boolean {
  if (!imageUrl) return false;

  if (imageUrl.startsWith('/api/uploads') || imageUrl.startsWith('/uploads')) {
    return true;
  }

  try {
    const host = new URL(imageUrl).hostname.toLowerCase();
    if (EXTERNAL_IMAGE_HOSTS.some((h) => host.includes(h))) {
      return false;
    }
    if (host.includes('amazonaws.com') || host.startsWith('s3.')) {
      return true;
    }
    return false;
  } catch {
    return true;
  }
}

function extractStorageKey(imageUrl: string): string {
  if (imageUrl.startsWith('/api/uploads/')) {
    return imageUrl.replace('/api/uploads/', '');
  }
  if (imageUrl.startsWith('/uploads/')) {
    return imageUrl.replace(/^\//, '');
  }
  try {
    return new URL(imageUrl).pathname.replace(/^\//, '');
  } catch {
    return imageUrl;
  }
}

export async function resolveProfileImageUrl(imageUrl: string): Promise<string | null> {
  if (!imageUrl) return null;
  if (!shouldSignProfileImageUrl(imageUrl)) {
    return imageUrl;
  }

  try {
    const key = extractStorageKey(imageUrl);
    const response = await api.get(`/upload/file/${encodeURIComponent(key)}`);
    if (response.data.success && response.data.url) {
      return response.data.url;
    }
    return imageUrl;
  } catch {
    return imageUrl;
  }
}
